import { z } from 'zod';

export const agentConfigurationSearchSchema = z.object({
    automation_id: z.string().optional().catch(undefined),
});

// Run-status facets are local table state, not a shared link: only the open run
// belongs in the URL.
export const automationDetailSearchSchema = z.object({
    run: z.string().optional().catch(undefined),
});
